import { createAction, props, union } from '@ngrx/store';

export const copyToClipboard = createAction('[Shared / Clipboard] Error', props<{ message: string }>());

const all = union({
    copyToClipboard,
});
export type Actions = typeof all;
